import {FC} from 'react'
import {useListView} from '../../core/ListViewProvider'
import { SearchCertificateModel } from '../../core/_models'

type Props = {
  data: SearchCertificateModel
}

const CertificateCoCNumberCell: FC<Props> = ({data}) => {
  const {setItemIdForUpdate} = useListView()
  
  const openViewModal = () => {
    setItemIdForUpdate(data.id)
  }
  
  return (      
  <div className='menu-item px-3' title="click to view">
    <div className='menu-link px-3' onClick={openViewModal}>
      {data.cocNumber}
    </div>
  </div>                                        
  )
}

export {CertificateCoCNumberCell}
